// components/WhyChooseUs.jsx
import React from 'react';

const reasons = [
  { num: '01', title: 'Advanced Equipment', desc: 'State-of-the-art analyzers and diagnostic tools ensuring high precision and repeatability in every test result.' },
  { num: '02', title: 'Expert Pathologists', desc: 'All reports reviewed and validated by qualified, experienced pathologists for complete clinical accuracy.' },
  { num: '03', title: 'Fast Turnaround', desc: 'Most routine reports delivered within 24 hours. Urgent samples prioritized with same-day reporting when needed.' },
  { num: '04', title: 'Home Collection', desc: 'Can\'t visit us? Our trained phlebotomists come to your doorstep at your preferred time — safe and hygienic.' },
  { num: '05', title: 'Online Reports', desc: 'Receive your reports via WhatsApp or email. No need to visit just to collect — convenient and paperless.' },
  { num: '06', title: 'Affordable Pricing', desc: 'Transparent pricing with no hidden charges. Discounts available on health packages and senior citizens.' }
];

const WhyChooseUs = () => {
  return (
    <section id="why" className="py-20 px-8 bg-teal-dark">
      <div className="max-w-[1200px] mx-auto">
        <p className="text-[#7dd8cf] text-[0.75rem] font-semibold tracking-[2px] uppercase mb-3">Why SRM</p>
        <h2 className="text-4xl md:text-5xl text-white font-serif mb-4">Quality You Can Trust</h2>
        <p className="text-[#9dc8c4] max-w-md leading-relaxed">We combine modern equipment, expert professionals, and patient-first service to deliver results you can rely on.</p>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
          {reasons.map((r, idx) => (
            <div key={idx} className="bg-white/7 border border-white/12 rounded-2xl p-7">
              <div className="text-[#7dd8cf] text-3xl font-serif mb-3">{r.num}</div>
              <h3 className="text-white text-base font-serif mb-2">{r.title}</h3>
              <p className="text-[#9dc8c4] text-sm leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;